import lang from '../../lib/language';
import { MarketCapCategory } from '../../lib/models/fundamental/types';

export const MARKET_CAP_RADAR_ROW_COUNT = 4;
export const MARKET_CAP_RADAR_SYMBOL_NAME_LIMIT = 20;
export const MARKET_CAP_RADAR_SYMBOL_NAME_LIMIT_MOBILE = 16;

export const MARKET_CAP_RADAR_TABLE_HEADERS = [
  lang.commonEpicMoversSymbolName(),
  lang.marketCapRadarMarketCap(),
  lang.marketCapRadarPriceAndChange(),
];

export type MarketCapSortField = 'marketCap' | 'volume' | 'volumePercentage' | 'price' | 'changesPercentage';
export type MarketCapSortDirection = 'asc' | 'desc';

export const MARKET_CAP_RADAR_DEFAULT_SORT_DIRECTION: MarketCapSortDirection = 'desc';
export const MARKET_CAP_RADAR_INTERNAL_SKELETON_ROWS = 6;
export const MARKET_CAP_RADAR_INTERNAL_NAME_LIMIT = 24;

export type MarketCapInternalColumn = {
  label: string;
  sortField?: MarketCapSortField;
};

export const MARKET_CAP_RADAR_INTERNAL_COLUMNS: MarketCapInternalColumn[] = [
  { label: lang.headerAccountBreakdownSymbolName() },
  { label: lang.commonChart() },
  { label: lang.marketCapRadarMarketCap(), sortField: 'marketCap' },
  { label: lang.marketCapRadarVolume(), sortField: 'volume' },
  { label: lang.marketCapRadarVolumePercentage(), sortField: 'volumePercentage' },
  { label: lang.commonLastPrice(), sortField: 'price' },
  { label: lang.commonPercentChange(), sortField: 'changesPercentage' },
];

export type MarketCapCategoryOption = {
  category: MarketCapCategory;
  label: string;
  range: string;
};

export const MARKET_CAP_CATEGORY_OPTIONS: MarketCapCategoryOption[] = [
  {
    category: MarketCapCategory.MegaLarge,
    label: lang.marketCapRadarCategoryMegaLarge(),
    range: lang.marketCapRadarRangeMegaLarge(),
  },
  {
    category: MarketCapCategory.Large,
    label: lang.marketCapRadarCategoryLarge(),
    range: lang.marketCapRadarRangeLarge(),
  },
  {
    category: MarketCapCategory.Mid,
    label: lang.marketCapRadarCategoryMid(),
    range: lang.marketCapRadarRangeMid(),
  },
  {
    category: MarketCapCategory.Small,
    label: lang.marketCapRadarCategorySmall(),
    range: lang.marketCapRadarRangeSmall(),
  },
  {
    category: MarketCapCategory.Penny,
    label: lang.marketCapRadarCategoryPenny(),
    range: lang.marketCapRadarRangePenny(),
  },
];
